import React from 'react';

export default () => (
  <section aria-labelledby="refundPolicyTitle" className="refund-policy">
    <h2 id="refundPolicyTitle">Refund Policy</h2>
    <p>
      If you would like to receive a refund there is a grace period of 5 days from the day of the renewal.
    </p>
  </section>
);
// If you purchase a Teacher Premium subscription, and then your school purchases a School Premium subscription, you will be refunded the remainder of your Teacher Premium as Quill Premium Credit. You can redeem your Premium Credit anytime you do not currently have an active subscription, and you will be resubscribed to Quill Premium for the amount of time you have in credit.
